const getDisabledStatus = (rootState) => rootState.ui.disabledStatus;

export default getDisabledStatus;
